<script>
import Modal from "./Modal";

export default {
  components: {
    Modal
  },

  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: "Esta ação não poderá ser desfeita"
    }
  }
};
</script>

<template>
  <Modal :title="title" :subtitle="subtitle" size="sm" @close="$emit('close')">
    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">fechar</button>
      <button
        class="btn bg-purple"
        :class="{'btn--loading': preloader}"
        @click="$emit('confirmed')"
      >
        <span>Deletar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Confirmation.vue